<template>
  <div>
  <section class="why-hero relative min-h-[72vh] flex items-start pt-20 lg:pt-28 pb-12">
    <!-- Background (left empty for now) -->
    <div class="absolute inset-0 bg-cover bg-center" :style="backgroundStyle" aria-hidden="true"></div>

    <!-- Dark overlay for readability -->
    <div class="absolute inset-0 bg-black/70"></div>

    <!-- Content -->
    <div class="relative z-10 w-full">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-white">
        <div class="ml-0 sm:ml-4 md:ml-8 lg:ml-20 xl:ml-32 max-w-2xl">
          <h1 class="text-5xl sm:text-6xl lg:text-4xl xl:text-4xl font-bold mb-10 text-left leading-tight">
            {{ getContent('why_choose_hero_title', '新一代互联网券商') }}
          </h1>
          <p class="text-base sm:text-lg lg:text-xl mb-6 text-left opacity-95">
            {{ getContent('why_choose_hero_subtitle', '持续连接科技与财富·重塑认知和发现之美') }}
          </p>

          <div class="prose prose-invert text-left max-w-none">
            <p>
              {{ getContent('why_choose_intro_1', '红土证券是服务全球投资者的新一代互联网券商，致力于连通资产的「发现—认知—交易」环节，为全球投资者带来安全可靠、高效便捷的全球投资体验。') }}
            </p>
            <p>
              {{ getContent('why_choose_intro_2', '我们成立于2019年3月，在美国、新加坡、香港、新西兰等地持有22张金融合规牌照或资质，并获得多家大型金融及投资机构的战略投资超过1.5亿美元。') }}
            </p>
            <p>
              {{ getContent('why_choose_intro_3', '我们的核心管理层由来自金融行业经验丰富的金融管理者和全球顶尖互联网科技企业的技术专家组成，他们拥有丰富的全球金融市场从业经验和实力出众的金融科技研发能力。') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    </section>



    <!-- 第二部分：橙色左右分栏 -->
    <section class="why-features bg-[#ef7c5b] text-white py-16 lg:py-24">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">
          <!-- 左侧文字区域 -->
          <div class="w-full lg:w-1/2 relative">
            <h2 class="text-2xl lg:text-3xl font-bold mb-4">{{ getContent('why_choose_feature_title', '香港持牌券商 安全可靠 值得托付') }}</h2>
            <p class="text-sm lg:text-base leading-relaxed mb-6">
              {{ getContent('why_choose_feature_desc', '红土证券具有提供证券交易、期货合约交易、就证券买卖提供意见、提供资产管理的资质，资产安全受监管定期严格审查及内外部审计。此外，长桥仍在积极进行全球主要金融市场的合规布局，拓展全球市场。') }}
            </p>

        <!-- positioned icon (absolute within left column) -->
        <div class="absolute right-6 bottom--2">
          <img :src="getImageUrl('image_why_choose_feature_icon', '/assets/组207.png')" alt="">
        </div>
          </div>
          <!-- 右侧图像占位 -->
          <div class="w-full lg:w-1/2 flex items-center justify-center">
            <img :src="getImageUrl('image_why_choose_placeholder', '')" alt="" class="w-full max-w-md h-60 rounded-lg shadow-md object-cover" v-if="getImageUrl('image_why_choose_placeholder', '')" />
            <div class="placeholder-image w-full max-w-md h-60 bg-gray-200 rounded-lg shadow-md" v-else></div>
          </div>
        </div>
      </div>
</section>
  <!-- 第三部分：关键数据展示 -->
  <section class="stats-section bg-white py-16 lg:py-20">
    <div class="max-w-7xl mx-auto px-4 lg:px-8">
      <div class="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12">
        <!-- 左侧数字 -->
        <div class="w-full lg:w-1/2 flex items-center justify-center lg:justify-start">
          <div class="stat-number text-orange-500 font-extrabold text-4xl lg:text-6xl">
            {{ getContent('why_choose_stats_number', '1,657,890+') }}
          </div>
        </div>

        <!-- 右侧说明 -->
        <div class="w-full lg:w-1/2">
          <h3 class="text-xl lg:text-2xl font-bold text-gray-900 mb-3">{{ getContent('why_choose_stats_title', '备受青睐获上亿美金级战略投资') }}</h3>
          <p class="text-gray-700 text-sm lg:text-base leading-relaxed">
            {{ getContent('why_choose_stats_desc', '红土备受投资人青睐，已获各类大型金融集团、投资机构战略投资超1.5亿美元') }}
          </p>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
import { getContentsByCategory, ContentMixin } from '../services/contentService';

export default {
  name: 'WhyChoose',
  mixins: [ContentMixin],
  props: {
    backgroundImage: {
      type: [String, Object],
      default: ''
    }
  },
  data() {
    return {
      content: {}, // 存储从API获取的内容
      loading: true,
      error: null,
      currentLocale: localStorage.getItem('locale') || 'zh'
    }
  },
  computed: {
    currentLang() {
      // 从localStorage获取当前语言，映射到API格式
      const langMap = {
        'zh': 'cn',
        'zh-Hant': 'tw',
        'en': 'en'
      };
      return langMap[this.currentLocale] || 'cn';
    },
    backgroundStyle() {
      const backgroundImageUrl = this.getImageUrl('image_why_choose_background', '')
      if (backgroundImageUrl) {
        return {
          backgroundImage: `url(${backgroundImageUrl})`
        }
      }
      return {
        background:
          'radial-gradient(ellipse at center, rgba(10,25,47,0.9) 0%, rgba(3,8,16,0.9) 100%)'
      }
    }
  },
  mounted() {
    this.loadContent();
    // 监听语言切换事件
    window.addEventListener('localeChange', this.handleLocaleChange);
  },
  beforeDestroy() {
    window.removeEventListener('localeChange', this.handleLocaleChange);
  },
  methods: {
    handleLocaleChange(e) {
      if (e.detail && e.detail.locale) {
        this.currentLocale = e.detail.locale;
        this.loadContent();
      }
    },
    async loadContent() {
      try {
        this.loading = true;
        this.error = null;
        // 获取why_choose所有内容
        const whyChooseContent = await getContentsByCategory('why_choose', this.currentLang);
        this.content = whyChooseContent;

        // 将获取到的内容同步到 Mixin 的数据中，避免重复请求
        this.contentData = { ...this.contentData, ...whyChooseContent };

        // 提取图片URL到 imageUrls
        Object.keys(whyChooseContent).forEach(key => {
          if (whyChooseContent[key] && (key.startsWith('image_') || whyChooseContent[key].startsWith('/uploads/') || whyChooseContent[key].startsWith('http'))) {
            // 如果是图片类型的key，或者是图片路径值
            this.$set(this.imageUrls, key, whyChooseContent[key]);
          }
        });

        // 获取图片配置（如果有额外的图片配置分类）
        const imageContent = await getContentsByCategory('images', this.currentLang);
        if (imageContent) {
            Object.keys(imageContent).forEach(key => {
                this.$set(this.imageUrls, key, imageContent[key]);
            });
        }

      } catch (error) {
        console.error('加载内容失败:', error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.why-hero {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.prose p {
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.9;
}

/* local styles for second section */
.dashed-icon {
  width: 48px;
  height: 48px;
  border: 2px dashed rgba(255,255,255,0.5);
  border-radius: 6px;
}
.dashed-icon .icon-dollar {
  color: rgba(255,255,255,0.95);
  font-weight: 700;
}
.placeholder-image {
  min-height: 12rem;
}
</style>
